import { API } from '@/api';
import axios from 'axios';

const state = {
};
const getters = {
};

const actions = {

  async generarEgresos({ commit, State }, { admin, condo, complementosDTO }) {
    const response = await API.post(`/reportes/egresos/generar/${admin.id}/${condo.id}/`, complementosDTO);
    return response.data;
  },

};
const mutations = {
};

export default {
  actions,
  getters,
  mutations,
  state,
};
